import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowIssuesController extends Controller {}
